import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextLink } from "@cinch-labs/design-system";
import Link from "next/link";
import styles from "./keyword-list.module.css";
export const KeywordList = ({ items  })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.keywords,
        "data-testid": "jargon-keywords",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.header,
                children: "Keywords"
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.list,
                children: items && items.map((keyword, index)=>/*#__PURE__*/ _jsx("li", {
                        className: styles.item,
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: `/jargon?q=${keyword}`,
                            passHref: true,
                            legacyBehavior: true,
                            children: /*#__PURE__*/ _jsx(TextLink, {
                                className: styles.link,
                                children: keyword
                            })
                        })
                    }, index))
            })
        ]
    });
